import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AnsprechpartnerPopoverPageRoutingModule } from './ansprechpartner-popover-routing.module';

import { AnsprechpartnerPopoverPage } from './ansprechpartner-popover.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    IonicModule,
    AnsprechpartnerPopoverPageRoutingModule
  ],
  declarations: [AnsprechpartnerPopoverPage]
})
export class AnsprechpartnerPopoverPageModule {}
